var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.6667C0.966667 13.6667 0.652667 13.5363 0.391333 13.2754C0.130444 13.014 0 12.7 0 12.3334V3.00004H1.33333V12.3334H8.66667V13.6667H1.33333ZM4 11C3.63333 11 3.31956 10.8696 3.05867 10.6087C2.79733 10.3474 2.66667 10.0334 2.66667 9.66671V1.66671C2.66667 1.30004 2.79733 0.986041 3.05867 0.724707C3.31956 0.463818 3.63333 0.333374 4 0.333374H10C10.3667 0.333374 10.6807 0.463818 10.942 0.724707C11.2029 0.986041 11.3333 1.30004 11.3333 1.66671V9.66671C11.3333 10.0334 11.2029 10.3474 10.942 10.6087C10.6807 10.8696 10.3667 11 10 11H4ZM4 9.66671H10V1.66671H4V9.66671Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.33a1802d976cc4a100936132200a4e17.svg";
export { ForwardRef as ReactComponent };